import React from 'react';
import './LoginPage.css';
import BASE from '../api';

export default function LoginPage({ redirect, error, errorEmail }) {
  const AUTH_BASE = process.env.REACT_APP_AUTH_URL || BASE;
  const loginUrl = `${AUTH_BASE}/auth/google?redirect=${encodeURIComponent(redirect || '/serving')}`;

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-icon">🍜</div>
        <h1 className="login-title">全民素食</h1>
        <p className="login-sub">管理後台登入</p>

        {error === 'denied' && (
          <div className="login-error">
            <p>此帳號無存取權限</p>
            {errorEmail && <p className="login-error-email">{errorEmail}</p>}
            <p className="login-error-sub">請聯絡管理員</p>
          </div>
        )}
        {(error === 'failed' || error === 'cancelled') && (
          <div className="login-error">登入失敗，請再試一次</div>
        )}

        <a className="google-btn" href={loginUrl}>
          <svg viewBox="0 0 48 48" width="20" height="20" style={{ flexShrink: 0 }}>
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          使用 Google 帳號登入
        </a>
      </div>
    </div>
  );
}
